import { Category } from 'TYPES/api.body';
import { Empty } from 'components/atoms';
import { Product } from 'components/molecules/Goods/Product';
import React from 'react';
import { GridContainer } from 'styles/grids';
import ProductSkeletons from './ProductSkeletons';

interface Props {
  products: {
    productId: number;
    name?: string;
    productName?: string;
    price: number;
    quantityAvailable: number;
    minimumOrderQuantity: number;
    bulkOrderPrice: number;
    barCode: string;
    images?: string | string[];
    productImage1: string | string[];
    productImage2?: string | string[];
    productImage3?: string | string[];
    likes?: number;
    status: string;
    description: string;
    seller: {
      seller_logo: string;
      businessName: string;
      id: number;
    };
    category?: Category;
  }[];
  diva?: any;
  isLoading: boolean;
  skeletonCount?: number;
  emptyMessage?: string;
  showEmptyPrompt?: boolean;
  emptyText?: string;
}

const ProductsGrid: React.FC<Props> = ({
  diva,
  products,
  isLoading,
  skeletonCount,
  showEmptyPrompt = true,
  emptyText
}) => {
  // Remove duplicates based on productId and sort products: in-stock items first, out-of-stock items last
  const uniqueProducts = products.filter((product, index, self) =>
    index === self.findIndex(p => p.productId === product.productId)
  );

  const sortedProducts = uniqueProducts.sort((a, b) => {
    // If both are in stock or both are out of stock, maintain original order
    if ((a.quantityAvailable > 0 && b.quantityAvailable > 0) ||
      (a.quantityAvailable === 0 && b.quantityAvailable === 0)) {
      return 0;
    }
    // If a is in stock and b is out of stock, a comes first
    if (a.quantityAvailable > 0 && b.quantityAvailable === 0) {
      return -1;
    }
    // If a is out of stock and b is in stock, b comes first
    return 1;
  });

  return (
    <>
      <GridContainer>
        {sortedProducts.map(product => (
          <div key={product?.productId}>
            <Product product={product} />
          </div>
        ))}
        {isLoading && <ProductSkeletons count={skeletonCount ?? 6} />}
      </GridContainer>
      {!isLoading && showEmptyPrompt && products.length < 1 && (
        <Empty message={emptyText ?? 'Unfortunately, there are no items in this category.'} />
      )}
    </>
  );
};

export default ProductsGrid;
